<template>
  <div class="min-vh main-theme">
    <div class="p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} TEAM
      </h1>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col cols="12">
          <InputText
            textFloat="Name"
            placeholder="Name"
            type="text"
            name="nameApi"
            v-model="form.name"
            isRequired
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
      </b-row>
      <div class="mt-2 border" v-if="this.form.roleMappingId">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break"
            >Team Admin List (at least one admin)</span
          >
        </div>
        <div class="p-3">
          <button
            class="create-button mb-3"
            @click="openModal('Team/add/supervisor', 4)"
          >
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> ADD TEAM ADMIN</span>
          </button>
          <b-table
            responsive
            striped
            hover
            class="table-list"
            :items="items"
            :fields="fields"
            :busy="isBusy"
            show-empty
            :empty-text="$t('noData')"
          >
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(id)="data">
              <div class="d-flex justify-content-center">
                <b-link
                  class="text-link ml-3"
                  @click="onDeleteModal(data.item, true)"
                >
                  <font-awesome-icon
                    icon="trash-alt"
                    class="text-danger"
                    title="Delete"
                  />
                </b-link>
              </div>
            </template>
          </b-table>
          <span class="text-error" v-if="$v.items.$error">กรุณากรอกข้อมูล</span>
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-end justify-content-sm-end"
            >
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filterSupervisorer.pageNo"
                  :total-rows="rows"
                  :per-page="filterSupervisorer.perPage"
                  class="m-md-0"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="mt-2 border" v-if="this.form.roleMappingId">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break">Agent List</span>
        </div>
        <div class="p-3">
          <button
            class="create-button mb-3"
            @click="openModal('Team/add/agent', 2)"
          >
            <font-awesome-icon icon="plus-square" />
            <span class="ml-2"> ADD AGENT</span>
          </button>
          <b-table
            responsive
            striped
            hover
            class="table-list"
            :items="itemsAgent"
            :fields="fields"
            :busy="isBusy"
            show-empty
            :empty-text="$t('noData')"
          >
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(id)="data">
              <div class="d-flex justify-content-center">
                <b-link
                  class="text-link ml-3"
                  @click="onDeleteModal(data.item, false)"
                >
                  <font-awesome-icon
                    icon="trash-alt"
                    class="text-danger"
                    title="Delete"
                  />
                </b-link>
              </div>
            </template>
          </b-table>
          <!-- <span class="text-error" v-if="$v.itemsAgent.$error"
            >กรุณากรอกข้อมูล</span
          > -->
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="form-inline justify-content-end justify-content-sm-end"
            >
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filterAgent.pageNo"
                  :total-rows="rowsAgent"
                  :per-page="filterAgent.perPage"
                  class="m-md-0"
                  @change="paginationAgent"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/team">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5"
              >CANCEL</b-button
            >
          </router-link>
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            {{ this.form.roleMappingId ? "SAVE" : "CONTINUE" }}
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalUser
      ref="ModalUser"
      :path="path"
      :roleId="roleId"
      :roleMappingId="form.roleMappingId"
      @reloadData="reloadData"
    />
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalUser from "./components/ModalUser.vue";

import { required, url, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingTime",
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    ModalAlertConfirm,
    ModalUser,
  },
  validations() {
    return {
      form: {
        name: { required },
      },
      items: { required },
      // itemsAgent: { required },
    };
  },
  data: function () {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        externalId: "",
        roleMappingId: "",
      },
      isDisabled: false,
      isLoading: true,
      tabIndex: 0,
      id: this.$route.params.id,
      rows: 0,
      roleId: "",
      rowsAgent: 0,
      startPage: 1,
      endPage: 10,
      path: "",
      filterAgent: {
        search: "",
        pageNo: 1,
        perPage: 10,
      },
      filterSupervisorer: {
        search: "",
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "name",
          label: "Name",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "email",
          label: "Email",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "role",
          label: "Role",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      isBusy: false,
      items: [],
      itemsAgent: [],
      form: {
        brandID: parseInt(this.$store.getters.getCurrentBrandID()),
      },
      flag: null,
    };
  },
  created: async function () {
    this.isLoading = true;
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    this.$v.$reset();

    if (this.id) {
      await this.getDetail();
      await this.getListSupervisor();
      await this.getListAgent();
    }
    this.isLoading = false;
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    pagination(Page) {
      this.filterSupervisorer.pageNo = Page;
      this.getListSupervisor();
    },
    paginationAgent(Page) {
      this.filterAgent.pageNo = Page;
      this.getListAgent();
    },
    async openModal(path, roleId) {
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.path = path;
      this.roleId = roleId;
      setTimeout(async () => {
        await this.$store.commit("UPDATE_MAIN_LOADING", false);
        await this.$refs.ModalUser.onShowModal();
      }, 100);
    },
    async reloadData() {
      this.isBusy = true;
      if (this.path.includes("supervisor")) await this.getListSupervisor();
      else await this.getListAgent();
      this.isBusy = false;
    },
    getDetail: async function () {
      await this.axios
        .get(`${this.$baseUrl}/Team/detail/name/${this.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      let path = "";
      if (this.flag) {
        path = "Team/delete/supervisor";
      } else path = "Team/delete/agent";

      await this.axios
        .post(`${this.$baseUrl}/${path}`, this.bodyDelete)
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            if (this.flag) await this.getListSupervisor();
            else await this.getListAgent();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    getListSupervisor: async function () {
      await this.axios
        .post(
          `${this.$baseUrl}/Team/list/supervisor/${this.id}`,
          this.filterSupervisorer
        )
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.data;
            this.rows = data.detail.count;
          }
        });
    },
    getListAgent: async function () {
      await this.axios
        .post(`${this.$baseUrl}/Team/list/agent/${this.id}`, this.filterAgent)
        .then((data) => {
          if (data.result == 1) {
            this.itemsAgent = data.detail.data;
            this.rowsAgent = data.detail.count;
          }
        });
    },
    onDeleteModal(data, flag) {
      this.flag = flag;
      this.bodyDelete.externalId = data.adminExternalId;
      this.bodyDelete.roleMappingId = data.roleMappingId;
      this.modalMsgDelete = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.form.roleMappingId) {
        if (
          this.$v.form.$error ||
          this.$v.items.$error
        ) {
          return;
        }
      } else {
        if (this.$v.form.$error) {
          return;
        }
      }

      this.isDisabled = true;
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      await this.axios
        .post(`${this.$baseUrl}/Team/detail/name`, this.form)
        .then((data) => {
          if (data.result == 1) {
            if (this.form.roleMappingId) {
              this.handleSuccess(data.message);
            } else {
              this.$router
                .push({ path: `/team/${data.detail.roleMappingId}` })
                .catch(() => {});
            }
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
      this.isDisabled = false;
      await this.$store.commit("UPDATE_MAIN_LOADING", false);
    },
    async handleSuccess(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT", { isShow: true, msg: msg });
      this.$router.push({ path: `/team` }).catch(() => {});
    },
    async handleFail(msg = false) {
      this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
        isShow: true,
        msg: msg,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add {
  position: absolute;
  top: 10px;
  right: 15px;
}
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
